import { useMutation, useQueryClient } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// PATCH /api/inventory/items/:itemId/strip-size — setItemStripSize(). Writes ONLY
// items.size — a deliberate, narrow exception to this codebase's "no second write path
// into shared master data" rule (see src/v2/inventory/pages/catalogue/index.jsx and
// setItemStripSize's doc comment in pillup-api for the full reasoning).
//
// No suggestion recomputation happens here or in the caller — on success this
// invalidates the shortages query so the next GET /api/inventory/shortages read
// recomputes the row server-side, the one place calculateShortages' formula lives.
export default function useSetItemStripSize() {
    const queryClient = useQueryClient();

    return useMutation(
        async ({ itemId, size }) => {
            const result = await request({
                url: `inventory/items/${itemId}/strip-size`,
                method: "PATCH",
                data: { size },
            });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;
            return body.data;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(["pharmacy-procurement-shortages"]);
            },
        }
    );
}
